<template>
  <div :class="$style.Navigation">
    <NavigationItem
      v-for="item in menu"
      :key="item.id"
      :item="item"
    />
  </div>
</template>

<script>
// import { matchesRoute } from '../../utils'
import NavigationItem from './NavigationItem.vue'

export default {
  name: 'Navigation',
  components: {
    NavigationItem
  },
  props: {
    menu: {
      type: Array
    }
  },
  methods: {
    onClick(item) {
      if (item.url) {
        // this.$navigate(item.url)
      }
    }
    // isMatch(item) {
    //   // return matchesRoute(item.url, this.$route)
    // }
  }
}
</script>


<style lang="scss" module>
@import '../../styles/variables';

.VerticalNav {
  width: $appNavWidth;
  margin-top: 20px;
}
</style>
